import {
  DefaultButton,
  IconButton,
  Modal,
  PrimaryButton,
} from "@fluentui/react";
import React, { useContext } from "react";
import { t } from "i18next";
import ModalHeader from "../../../components/Modal/ModalHeader";
import ModalFooter from "../../../components/Modal/ModalFooter";
import loaderContext from "../../../context/loader/LoaderContext";
import ModalMain from "../../../components/Modal/ModalMain";
import themeContext from "../../../context/theme/ThemeContext";
import { darkTheme, duskTheme, lightTheme, royalBlueTheme } from "../../../constants/Themes";
import { MODAL_TYPE } from "../../../constants/Constants";
import { updateUserSettings } from "../../../service/UserService";
import userContext from "../../../context/users/UserContext";

const ThemePreference = (props) => {
  const { showModal, setShowModal, setLoaderRunning, ref } = useContext(loaderContext);
  const { theme, themeName, setThemeName, setTheme, setUserSettings, handleThemeProviderChange} = useContext(themeContext);
  const { userId, userSettings } = useContext(userContext);

  const handleCloseModal = () => {
    console.log("--- Update ---",userSettings, showModal);

    setShowModal({ show: false });
  
    
  };

  const changeTourUpdate = async(themeValue,studyListTour,viewerTour,showThemePreference) => {
    let body = {
      userSettings:{
        "theme":themeValue,
        "studylistTour":studyListTour == null || studyListTour == undefined ? true : studyListTour,
        "viewerTour":viewerTour == null || viewerTour == undefined ? false : viewerTour,
        "showThemePreference": showThemePreference != null && showThemePreference != undefined ? showThemePreference : false,
      }
      
    }
    console.log("-- Body ---",body);
    try{
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await updateUserSettings(body.userSettings);
      if (response.status === 200 && response.data.result === "SUCCESS") {
          setUserSettings(body.userSettings);
          setLoaderRunning(false);
          ref.current.complete();
      }else{
        setLoaderRunning(false);
        ref.current.complete();
      }
    }catch(e){
      setLoaderRunning(false);
      ref.current.complete();
    }
  }

  const changeTheme = async(value) => {
    handleThemeProviderChange(value);
    setThemeName(value);
    changeTourUpdate(value,userSettings.studyListTour,userSettings.viewerTour,false);
  };

  let DefaultButtonList = [
    {
      title: t("button.done"),
      onclick: () => {
        console.log("Done");
        handleCloseModal();
      },
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading="Customize Your Theme Experience"
        handleCancel={() => handleCloseModal()}
      />
    ),
    body: <ThemePreferenceBody changeTheme={changeTheme} handle />,
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "1000px",
  };

  return (
    <>
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
    </>
  );
};

export default ThemePreference;

const ThemePreferenceBody = ({ changeTheme }) => {
  const { theme, themeName, setThemeName, setTheme, getThemeColor,showLightTheme } = useContext(themeContext);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
          boxSizing: "border-box",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: getThemeColor("primary-color"),
            fontSize: "14px",
            display: "flex",
            justifyItems: "center",
            marginBottom: "20px",
            marginTop: "10px",
            fontStyle: "italic",
          }}
        >
          Please choose your preferred theme to enhance your browsing
          experience.
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItem: "center",
            width: "100%",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <img
              onClick={() => changeTheme("dark-midnight")}
              width={200}
              height={100}
              src={`${window.location.origin}/images/theme-midnight-dark.png`}
              style={{
                border: `3px solid ${
                  themeName === "dark-midnight" ? "green" : "#bfbfbf"
                }`,
                borderRadius: "7px",
              }}
            />
            <p style={{ color: getThemeColor("primary-color"), fontSize: "12px" }}>Midnight Dark</p>
          </div>
          <div style={{ textAlign: "center" }}>
            <img
              onClick={() => changeTheme("blue-theme")}
              width={200}
              height={100}
              src={`${window.location.origin}/images/royal-blue.png`}
              style={{
                border: `3px solid ${
                  themeName === "blue-theme" ? "green" : "#bfbfbf"
                }`,
                borderRadius: "7px",
              }}
            />
            <p style={{ color: getThemeColor("primary-color"), fontSize: "12px" }}>Royal Blue</p>
          </div>
          <div style={{ textAlign: "center" }}>
            <img
              onClick={() => changeTheme("dark")}
              width={200}
              height={100}
              src={`${window.location.origin}/images/dusk.png`}
              style={{
                border: `3px solid ${
                  themeName === "dark" ? "green" : "#bfbfbf"
                }`,
                borderRadius: "7px",
              }}
            />
            <p style={{ color: getThemeColor("primary-color"), fontSize: "12px" }}>Dusk</p>
          </div>
          {sessionStorage['isLightThemeUser']==='true' && <div style={{ textAlign: "center" }}>
            <img
              onClick={() => changeTheme("light")}
              width={200}
              height={100}
              src={`${window.location.origin}/images/light.png`}
              style={{
                border: `3px solid ${
                  themeName === "light" ? "green" : "#bfbfbf"
                }`,
                borderRadius: "7px",
              }}
            />
            <p style={{ color: getThemeColor("primary-color"), fontSize: "12px" }}>Light</p>
          </div>}
        </div>
        <div
          style={{
            //color: "#a5a5a5",
            color: themeName != "light" ? "#a5a5a5" : "#3d3d3d",
            fontSize: "14px",
            display: "flex",
            justifyItems: "center",
            marginBottom: "10px",
            marginTop: "20px",
            fontStyle: "italic",
            textAlign: "center",
            fontWeight: "bold"
          }}
        >
          Note: If you choose to skip the selection, the default theme will be applied. You can update the theme later through the profile and preferences menu located in the top-right corner.
        </div>
      </div>
    </>
  );
};
